import { Injectable } from '@angular/core';
import { SecurityService } from './security.service';
import { ApiService } from './communications/api.service';
import { SignalRService } from './communications/signalr.service';
import { UserDataService } from './userData.service';
import { Observable } from 'rxjs';
import * as constants from '../constants/constants';
import { WhitelabelService } from './whitelabel.service';


@Injectable({
  providedIn: 'root'
})

export class LoginService {
  answer = '';
  constructor(private securityService: SecurityService, private apiService: ApiService, private signalRService: SignalRService, private userDataService: UserDataService, private whiteLabelService: WhitelabelService) { }

  public loginToken(token: string): Observable<string> {

    console.log("Logintoken - saveToken", token);

    this.securityService.saveUrlToken(token);
    localStorage.setItem('token', token);

    return new Observable<string>(observer => {
      this.apiService.loginToken(token).subscribe({
        next: async data => {
          console.log("LOGIN: ", data.userName);

          this.securityService.addSecurityToken(data);
          this.userDataService.set(data.userId, data.userName, data.role, data.assetId, data.logoHeader, data.favicon, data.assistanceId);
          if (data.companyName.length > 0) {
            this.whiteLabelService.currentWhitelabel = data.companyName;
            this.whiteLabelService.initService();
          }

          this.signalRService.connect().then(() => {
            console.log("SendSignalRConnection");
            this.signalRService.sendSignalRConnectionData(data.userId!, data.assetId!, data.userName, data.role!);
          });

          console.log("observer.next OK");
          observer.next(constants.Result_Ok);
          observer.complete();
        },
        error: error => {
          console.error('There was an error!', error.error);
          observer.error(error.error);
        }
      });
    });
  }

}
